module.exports = __webpack_public_path__ + "ps.33a2122a.svg";